export default __webpack_public_path__ + "static/circle-background-7a86957ff908f719205ad9b7c850c189.png";